import { ref, computed } from 'ui.vue3';
import MapFilterCheckListComponent from "./MapFilterCheckListComponent";
import VfnSelect from "./VfnSelect";
import MapSearchComponent from "./MapSearchComponent";
import {getIsMobile} from "../lib/isMobile";

export default {
  name: 'MapFilterComponent',
  components: {
    MapFilterCheckListComponent,
    MapSearchComponent,
    VfnSelect
  },
  props: [
    'points',
    'searchPlaceholder',
    'categoriesList',
    'activeFilterCategory',
    'shopTypesList',
    'activeFilterShopType',
    'countryList',
    'activeFilterCountry',
    'allCountriesItem',
    'citiesList',
    'activeFilterCity',
    'allCitiesItem',
    'countryPlaceholder',
    'citiesPlaceholder',
  ],
  emits: ['close', 'clear', 'apply', 'search-select-point', 'search-select-address'],
  setup(props, {emit}) {
    
    const isMobile = getIsMobile();
    
    // Локальные значения
    const localActiveFilterShopType = ref([...props.activeFilterShopType]);
    const localActiveFilterCategory = ref([...props.activeFilterCategory]);
    const localActiveFilterCountry = ref(props.activeFilterCountry);
    const localActiveFilterCity = ref(props.activeFilterCity);
    
    const disabledFilterShopType = computed(() => {
      return false;
    })
    const disabledFilterCategory = computed(() => {
      return false;
    })
    const updateShopType = (code) => {
      if (localActiveFilterShopType.value.includes(code)) {
        localActiveFilterShopType.value = localActiveFilterShopType.value.filter(el => el !== code);
      } else {
        localActiveFilterShopType.value.push(code);
      }
    }
    const updateCategory = (code) => {
      if (localActiveFilterCategory.value.includes(code)) {
        localActiveFilterCategory.value = localActiveFilterCategory.value.filter(el => el !== code);
      } else {
        localActiveFilterCategory.value.push(code);
      }
    }
    
    const visibleCitiesList = computed(() => {
      if (!localActiveFilterCountry.value || localActiveFilterCountry.value.id === props.allCountriesItem.id) {
        return props.citiesList;
      }
      return props.citiesList.filter(city => {
        if (city.id === props.allCitiesItem.id) {
          return true;
        }
        return city.country_id === localActiveFilterCountry.value.id
      });
    })
    
    const onSetActiveCountry = (country) => {
      localActiveFilterCountry.value = (!country || country === localActiveFilterCountry.value || country.id === props.allCountriesItem.id) ? props.allCountriesItem : country;
      localActiveFilterCity.value = props.allCitiesItem;
    }
    
    const onSetActiveCity = (city) => {
      localActiveFilterCity.value = (!city || city === localActiveFilterCity.value || city.id === props.allCitiesItem.id) ? props.allCitiesItem : city;
      if (localActiveFilterCity.value && (!localActiveFilterCountry.value || localActiveFilterCountry.value.id === props.allCountriesItem.id)) {
        const countryToSet = props.countryList.find(country => country.id === localActiveFilterCity.value.country_id);
        if (countryToSet) {
          localActiveFilterCountry.value = countryToSet;
        }
      }
    }
    
    // Установка базовых значений
    const setBaseValues = () => {
      localActiveFilterShopType.value = [...props.activeFilterShopType];
      localActiveFilterCategory.value = [...props.activeFilterCategory];
      localActiveFilterCountry.value = props.activeFilterCountry;
      localActiveFilterCity.value = props.activeFilterCity;
    }
    setBaseValues()
    
    // Тексты
    const title = 'Find us'
    const shopTypesTitle = 'Store'
    const categoryTitle = 'Category'
    const applyBtn = 'Apply'
    const clearBtn = 'Clear'
    const countryFieldPlaceholder = 'Country'
    const cityFieldPlaceholder = 'City'
    const selectSearchPlaceholder = 'Search country, city, index'

    const countryModel = computed(() => {
      return localActiveFilterCountry.value && localActiveFilterCountry.value.id !== props.allCountriesItem.id
        ? localActiveFilterCountry.value
        : null;
    })

    const cityModel = computed(() => {
      return localActiveFilterCity.value && localActiveFilterCity.value.id !== props.allCitiesItem.id
        ? localActiveFilterCity.value
        : null;
    })
    
    // Применение фильтра
    const applyFilter = () => {
      emit('apply', {
        shopTypes: [...localActiveFilterShopType.value],
        categories: [...localActiveFilterCategory.value],
        country: localActiveFilterCountry.value,
        city: localActiveFilterCity.value
      });
    }
    
    return {
      isMobile,
      title,
      shopTypesTitle,
      categoryTitle,
      localActiveFilterShopType,
      localActiveFilterCategory,
      updateShopType,
      updateCategory,
      localActiveFilterCountry,
      localActiveFilterCity,
      visibleCitiesList,
      onSetActiveCountry,
      onSetActiveCity,
      applyBtn,
      clearBtn,
      countryFieldPlaceholder,
      cityFieldPlaceholder,
      selectSearchPlaceholder,
      countryModel,
      cityModel,
      applyFilter,
      disabledFilterShopType,
      disabledFilterCategory
    }
  },
  template: `
    <div class="partners-map-filter">
      <div class="partners-map-filter__title">
        {{title}}
      </div>
      <MapSearchComponent class="partners-map-filter__search" :points="points" :placeholder="searchPlaceholder" @select-point="$emit('search-select-point', $event)" @select-address="$emit('search-select-address', $event)" />
      <MapFilterCheckListComponent class="partners-map-filter__section--first" :list="shopTypesList" :disabled="disabledFilterShopType" :activeList="localActiveFilterShopType" :title="shopTypesTitle" @update="updateShopType" />
      <MapFilterCheckListComponent :list="categoriesList" :activeList="localActiveFilterCategory" :disabled="disabledFilterCategory" :title="categoryTitle" @update="updateCategory" />
      <div class="partners-map-filter__section partners-map-filter__selects">
        <VfnSelect class="partners-map-filter__selects-item" :notAbsolute="isMobile" :notAutofocus="isMobile" :modelValue="countryModel" @update:modelValue="onSetActiveCountry" :options="countryList" :placeholder="countryFieldPlaceholder" :searchPlaceholder="selectSearchPlaceholder" />
        <VfnSelect class="partners-map-filter__selects-item" :notAbsolute="isMobile" :notAutofocus="isMobile" :modelValue="cityModel" @update:modelValue="onSetActiveCity" :options="visibleCitiesList" :placeholder="cityFieldPlaceholder" :searchPlaceholder="selectSearchPlaceholder" />
      </div>
      <div class="partners-map-filter__bottom">
        <button class="partners-map-filter__btn partners-map-filter__btn--apply" @click="applyFilter">{{applyBtn}}</button>
        <button class="partners-map-filter__btn partners-map-filter__btn--clear" @click="$emit('clear')">{{clearBtn}}</button>
      </div>
    </div>
  `,
}
